import { getExperiment } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';

export enum Position {
    Hidden = 'hidden',
    Top = 'top',
    Bottom = 'bottom',
}

interface Props {
    position: Position;
}

export const HighlightsExperimentWrapper: React.FC<Props> = ({
    position,
    children,
}) => {
    const [experimentPosition, setExperimentPosition] = useState(
        Position.Hidden,
    );

    useEffect(() => {
        const value = getExperiment<Position, Position>(
            'highlights_in_listing_page',
            'position',
            Position.Hidden,
        );

        setExperimentPosition(value);
    }, []);

    return experimentPosition === position ? <>{children}</> : <></>;
};
